const CUSTOM_EMBED_PREFIX = 'custom_embed:'

export const getKey = (subtype: string) => CUSTOM_EMBED_PREFIX + subtype

export const isCustomEmbedByKey = (key: string | undefined) =>
  !!key && key.indexOf(CUSTOM_EMBED_PREFIX) === 0

export const getSubtype = (key: string) =>
  key.replace(new RegExp('^' + CUSTOM_EMBED_PREFIX), '')
